import React from 'react';
import TileParticipant from './TileParticipant';
import { useMeetingTileContext } from '../MeetingTileContext';
import { FeedMember } from '../meeting-tile-utils';

interface TileMemberFeedProps {
    member: FeedMember;
}

/** A remote participant's camera feed, sized to fill its positioned wrapper.
 * A presenter's shared screen goes on the stage via TileRemoteStageScreenShare,
 * not here — this tile only ever renders their camera. */
const TileMemberFeed: React.FC<TileMemberFeedProps> = ({ member }) => {
    const context = useMeetingTileContext();
    return (
        <TileParticipant
            memberObject={member}
            isCompact={context.isCompact}
            showPinControl={context.pinControlEnabled}
        />
    );
};

// Memoized so a resize (which re-renders MeetingMainArea and rebuilds the tile
// elements every tick) doesn't re-render this subcomponent — and re-run
// TileParticipant's selectors — while its props are unchanged. `member` is a
// stable ref from the parent's memoized useMemberManagement; the tile context
// is memoized too. Only the leaf tile was memoized before, so this chain
// (TileMemberFeed -> TileParticipant) churned ~N selector evals per tick.
export default React.memo(TileMemberFeed);
